import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Preloader from '../../../components/common/Preloader';
import SubmitPIN from '../../../components/common/SubmitPIN';
import FormMessage from '../../FormMessage';
import Translation from '../../i18n/Translation';
import withOmni from '../../withOmni';
import { request, viewEnter } from '../actions';
import History from '../History';
import LearnMoreNote from '../LearnMoreNote';
import Pending from '../Pending';
import { STEP_AMOUNT, STEP_PIN, STEP_RESTRICTIONS, STEP_SUCCESS } from '../reducer';
import Request from '../Request';
import Restrictions from '../Restrictions';
import { getHistory, getStep, isHistoryLoaded, isPendingWithdrawal } from '../selectors';
import Success from '../Success';
import { getMobileNumber } from '../../../modules/account/selectors';
import { logOut } from '../../../modules/auth/actions';
import checkBlocked from '../../../utils/checkBlocked';

export class Withdraw extends Component {
  componentWillMount() {
    this.props.viewEnter();
  }

  render() {
    const { step, onSubmit, history, historyLoaded, pendingWithdrawal, mobileNumber, logOutAction } = this.props;
    checkBlocked(mobileNumber, logOutAction);

    if (!historyLoaded && step !== STEP_SUCCESS) {
      return (
        <div className="with-omni">
          <div className="with-omni__preloader">
            <Preloader>
              <Translation section="linkingAccounts" label="checking" />
            </Preloader>
          </div>
        </div>
      );
    }

    let requestComponent;
    if (pendingWithdrawal && step !== STEP_SUCCESS) {
      requestComponent = (<Pending />);
    } else if (step === STEP_RESTRICTIONS) {
      requestComponent = (<Restrictions />);
    } else if (step === STEP_AMOUNT) {
      requestComponent = (<Request />);
    } else if (step === STEP_PIN) {
      requestComponent = (
        <div>
          <SubmitPIN onSubmit={onSubmit} />
          <LearnMoreNote />
        </div>
      );
    } else if (step === STEP_SUCCESS) {
      requestComponent = (<Success />);
    }

    return (
      <div className="withdraw">
        <div className="container--fixed">
          <FormMessage className="withdraw__message" />
          {requestComponent}
          {!!history.size && <History history={history} />}
        </div>
      </div>
    );
  }
}

Withdraw.propTypes = {
  viewEnter: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  historyLoaded: PropTypes.bool,
  pendingWithdrawal: PropTypes.bool,
  logOutAction: PropTypes.func,
  mobileNumber: PropTypes.string
};

const mapStateToProps = state => ({
  step: getStep(state),
  history: getHistory(state),
  historyLoaded: isHistoryLoaded(state),
  pendingWithdrawal: isPendingWithdrawal(state),
  mobileNumber: getMobileNumber(state)
});

const mapDispatchToProps = {
  viewEnter,
  onSubmit: request,
  logOutAction: logOut
};

export default withOmni(connect(mapStateToProps, mapDispatchToProps)(Withdraw));
